import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function AcademyTeaser() {
  return (
    <section id="academy-teaser" className="relative py-24 md:py-36 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF6B00] mb-4">Pickle Wall Academy</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-balance leading-[0.95]">
              Train The Next <span className="text-[#FF6B00]">Generation.</span>
            </h2>
            <p className="mt-6 text-lg text-white/70 max-w-lg">
              Pickle Wall Academy brings structured repetition, skill development and the Pickle Wall training system to developing players.
            </p>
            <Link
              to="/academy"
              data-testid="academy-teaser-cta"
              onClick={() => trackEvent("cta_click", { button_text: "Explore the Academy", button_location: "home-academy-teaser" })}
              className="mt-8 group inline-flex items-center gap-2 bg-[#FF6B00] hover:bg-[#E66000] text-black font-bold uppercase tracking-wider text-sm px-7 py-4 transition-all hover:orange-glow"
            >
              Explore The Academy
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          <div className="rounded-3xl overflow-hidden border border-white/10 aspect-[4/3]">
            <img
              src="/pickle-wall-academy-tryouts.png"
              alt="Pickle Wall™ Academy training session"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
